import React, { useEffect, useState } from 'react';
import './CardsCantidad.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUsers, faImage, faBook, faStar, faCode } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import baseURL from '../../url';
import useApiWithLoader from '../../../hooks/useApiWithLoader';
export default function CardsCantidad() {
    const [rifas, setRifas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [numeros, setNumeros] = useState([]);
    const [ganadores, setGanadores] = useState([]);
    const { multipleApiCalls } = useApiWithLoader();

    useEffect(() => {
        loadAllData();
    }, []);

    const loadAllData = async () => {
        const fetchFunctions = [
            () => fetch(`${baseURL}/rifaGet.php`, { method: 'GET' })
                .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => setRifas(Array.isArray(data.rifas) ? data.rifas : []))
                .catch(error => {
                    console.error('Error loading rifas:', error);
                    setRifas([]);
                }),
            
            () => fetch(`${baseURL}/usuariosGet.php`, { method: 'GET' })
                .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => setUsuarios(Array.isArray(data.usuarios) ? data.usuarios : []))
                .catch(error => {
                    console.error('Error loading usuarios:', error);
                    setUsuarios([]);
                }),
            
            () => fetch(`${baseURL}/numeroGet.php`, { method: 'GET' })
                .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => setNumeros(Array.isArray(data.numeros) ? data.numeros : []))
                .catch(error => {
                    console.error('Error loading numeros:', error);
                    setNumeros([]);
                }),
            
            () => fetch(`${baseURL}/ganadorGet.php`, { method: 'GET' })
                .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => setGanadores(Array.isArray(data.ganadores) ? data.ganadores : []))
                .catch(error => {
                    console.error('Error loading ganadores:', error);
                    setGanadores([]);
                })
        ];

        await multipleApiCalls(fetchFunctions);
    };

    return (
        <div className='CardsCantidad'>

            <Anchor to={`/dashboard/usuarios`} className='cardCantidad'>
                <FontAwesomeIcon icon={faUsers} className='icons' />
                <div className='deColumn'>

                    <h3>Usuarios</h3>
                    <h2>{Array.isArray(usuarios) ? usuarios.length : 0}</h2>
                </div>

            </Anchor>
            <Anchor to={`/dashboard/rifas`} className='cardCantidad' >
                <FontAwesomeIcon icon={faStar} className='icons' />
                <div className='deColumn'>

                    <h3>Rifas</h3>
                    <h2>{Array.isArray(rifas) ? rifas.length : 0}</h2>
                </div>

            </Anchor>
            <Anchor to={`/dashboard/numeros`} className='cardCantidad' >
                <FontAwesomeIcon icon={faBook} className='icons' />
                <div className='deColumn'>

                    <h3>Numeros</h3>
                    <h2>{Array.isArray(numeros) ? numeros.length : 0}</h2>
                </div>

            </Anchor>

            <Anchor to={`/dashboard/ganadores`} className='cardCantidad' >
                <FontAwesomeIcon icon={faUser} className='icons' />
                <div className='deColumn'>

                    <h3>Ganadores</h3>
                    <h2>{Array.isArray(ganadores) ? ganadores.length : 0}</h2>
                </div>

            </Anchor>

        </div>
    )
}
